import { Sprite } from 'pixi.js';

export const UO_HUE_SPRITE_PIPE_ID = 'uoHueSprite';

/**
 * A sprite carrying Ultima Online hue data as render state.
 *
 * The custom render pipe consumes this state as vertex attributes, so adjacent
 * sprites may use different hue rows and modes without a filter boundary.
 */
export class UoHueSprite extends Sprite {
  override readonly renderPipeId = UO_HUE_SPRITE_PIPE_ID;
  private encodedHue = 0;
  private partial = false;
  private flash = 0;

  constructor(hue = 0, partialHue = false) {
    super();
    this.encodedHue = hue;
    this.partial = partialHue;
  }

  get hue(): number {
    return this.encodedHue;
  }

  set hue(value: number) {
    if (this.encodedHue === value) return;
    this.encodedHue = value;
    this.onViewUpdate();
  }

  get partialHue(): boolean {
    return this.partial;
  }

  set partialHue(value: boolean) {
    if (this.partial === value) return;
    this.partial = value;
    this.onViewUpdate();
  }

  get flashMix(): number {
    return this.flash;
  }

  set flashMix(value: number) {
    const clamped = Math.min(1, Math.max(0, value));
    if (this.flash === clamped) return;
    this.flash = clamped;
    this.onViewUpdate();
  }
}
